export default "__VITE_ASSET__DXVXZjPs__"